import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from "react-router-dom";

import evidenceActions from 'actions/evidenceActions';

import Sheet from 'components/core/Sheet';
import Card from 'components/core/Card';
import Grid from 'components/core/Grid';
import Typography from 'components/core/Typography';
import Button from 'components/core/Button';

import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';

import EvidenceForm from 'components/EvidenceForm';

const EvidenceAdd = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const evidences = useSelector(({ evidence }) => evidence.list);
    const currentUser = useSelector(({ auth }) => auth.me);

    useEffect(() => {
        dispatch(evidenceActions.list({ createdBy: currentUser.id }));
    }, [dispatch, currentUser.id]);

    const handleSubmit = (savedEvidence) => {
        navigate(`/evidence/${savedEvidence.id}`);
    };

    const handleBack = () => {
        window.history.back();
    };

    return (
        <Sheet sx={{ p: 4 }}>
            <Button
                variant="text" 
                onClick={handleBack}
                sx={{ padding: 2 }}
            >
                <ArrowBackIosIcon sx={{ fontSize: 18, marginRight: 1 }} />
                Back
            </Button>
            <Card>
                <Grid container spacing={4}>
                    <Grid item xs={12}>
                        <Typography variant="h4">Add New Evidence</Typography>
                    </Grid>
                    
                    <Grid item xs={12}>
                        <EvidenceForm 
                            evidences={evidences}
                            onSubmit={handleSubmit}
                        />
                    </Grid>
                </Grid>
            </Card>
        </Sheet>
    );
};

export default EvidenceAdd;